var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getQuoteSingle)?_c('div',[_c('appQuoteViewCom',{attrs:{"propsData":_vm.getQuoteSingle,"quoteType":'quote'},on:{"callSingleQuote":function($event){return _vm.fnCallSingleQuote()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }